import React from "react";
import { Button, Offcanvas } from "react-bootstrap";
import VerticalForm from "../../../components/forms/VerticalForm";
import FormInput from "../../../components/forms/FormInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ReviewLinkType } from "../../../features/users/user.interface";
import { useUpdateReviewLinksMutation } from "../../../features/users/usersApi";
import { toast } from "react-toastify";
import { useAppSelector } from "../../../Hook";

interface AddReviewPlatformProps {
  show: boolean;
  onHide: () => void;
}

export interface PlatformData {
  name: string;
  link: string;
  type?: ReviewLinkType;
  displayName: string;
}

const schemaResolver = yupResolver(
  yup.object().shape({
    name: yup.string().required("Please enter Plateform Name"),
    link: yup.string().required("Please enter Review link"),
    displayName: yup.string().required("Please enter Display label"),
  })
);

const AddReviewPlatform: React.FC<AddReviewPlatformProps> = ({
  show,
  onHide,
}) => {
  const formRef = React.useRef<any>(null);
  const reviewData = useAppSelector((state) => state.userSlice.reviewModalData);
  const [addReviewPlatform] = useUpdateReviewLinksMutation();

  const onSubmit = async (data: PlatformData) => {
    try {
      const reviewRes = await addReviewPlatform({
        name: data.name,
        link: data.link,
        type: data.type ?? ReviewLinkType.OTHER,
        display_name: data.displayName,
      }).unwrap();
      onHide();
      toast.success(reviewRes?.message ?? "Platform added successfully");
    } catch (e: any) {
      console.error(e?.message ?? "Error adding review platform");
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={"end"}
      style={{ width: "600px" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add you custom Plaform</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <VerticalForm<PlatformData>
          ref={formRef}
          onSubmit={onSubmit}
          resolver={schemaResolver}
          defaultValues={{
            name: reviewData?.name,
            link: reviewData?.link,
            displayName: reviewData?.displayName,
          }}
        >
          <FormInput
            label={"Platform Name"}
            type="text"
            name="name"
            placeholder="Eg. Google, microsoft"
            containerClass={"mb-3"}
          />
          <FormInput
            label={"Platform Link"}
            type="text"
            name="link"
            placeholder=""
            containerClass={"mb-3"}
          />

          <FormInput
            label={"Display Label"}
            type="text"
            name="displayName"
            placeholder="Eg. Review us on Google, microsoft"
            containerClass={"mb-3"}
          />

          <div className="flex justify-end">
            <Button type="submit">Add</Button>
          </div>
        </VerticalForm>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddReviewPlatform;
